exports = module.exports = require("../../../node_modules/.pnpm/css-loader@2.1.1_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.content[data-v-a92f9fa0] {\n    margin-bottom: 5px;\n    overflow: hidden;\n    transition: height .3s ease-in-out;\n}\na[data-v-a92f9fa0] {\n    text-decoration: underline;\n}\n", ""]);

